export default "__VITE_ASSET__Bn8e_N2w__"